import React from 'react';
import {Stub} from '@rocket-ui/components';

export function NotFoundPage(): React.ReactElement {
	return (
		<div className={'w-full h-full flex items-center justify-center'}>
			<Stub message={'Страница не найдена!'} emojiName="shrugging-female" />
		</div>
	);
}
